
import { Container } from '../../components/Container/Container';
import styles from './Age.module.scss';
import { useNavigate } from "react-router-dom";
import { useFetchData } from '../../services/useFetchData.service';
import { Spinner } from '../../components/Spinner/Spinner';
import { Block } from '../../components/Block/Block';
import { useUserData } from '../../providers/UserDataProvider/useUserData';
import { AnswerItem } from '../../components/AnswerItem/AnswerItem';
import { AnswerBlock } from '../../components/AnswerBlock/AnswerBlock';
import { Title } from '../../components/Title/Title';
// import { Subtitle } from '../../components/Subtitle/Subtitle';
import { Image } from '../../components/Image/Image';
import { useEffect } from 'react';
import { ampAgeSelected } from '../../utils/AmplitudeEvents';

const NEXT_PAGE_URL = '/quiz/1/';

const Age = ({dataUrl,theme}) => {
  const navigate = useNavigate();
  const { data } = useFetchData(dataUrl);
  const { userData, setUserData } = useUserData();
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);
  if ( !data) {
    return <Spinner />;
  }
  const { title,image, answers } = data;
  
  const handleAgeSelect = (age) => {
    setUserData({ ...userData, age });
    ampAgeSelected(age);
    setTimeout(() => navigate(NEXT_PAGE_URL), 500);
  };

  return (
    <>
      <Block>
        <Container className={styles.section}>
          {image && <Image src={image} className={styles.image}/>}
          {title && <Title className={styles.title}>{title}</Title>}
          {answers && (
            <AnswerBlock className={styles.age}>
              {answers.map((card, index) => {
                const isActive = userData?.age === card.answer;
                return (
                  <AnswerItem
                    key={index}
                    type="button"
                    status={isActive ? 'active' : null}
                    onClick={() => card.answer && handleAgeSelect(card.answer)}
                  >
                    {card}
                  </AnswerItem>
                );
              })}
            </AnswerBlock>
          )}
        </Container>
      </Block >
    </>
  )
}
export default Age;